import {useMutation} from '@apollo/client';
import {sprintMutations, sprintQueries} from 'api/graphql-queries/sprints';
import {
    SprintByBoardIdRequest,
    SprintCreateUpdateRequestModel,
    SprintModel,
    SprintPaginationResponse,
    SprintResponseModel,
} from 'models/sprint.model';

import {useCursorPaginationQuery} from 'hooks/useCommon';
import {useEffect} from 'react';
import {useAlert} from '../useAlert';

export const useGetAllSprints = () => {
    const {isLoading, fetchPaginated, upsertItemState, data} = useCursorPaginationQuery<
        SprintModel, // TItem
        SprintPaginationResponse, // TResponse
        SprintByBoardIdRequest, // TVariables
        'allSprints' // TKey (key inside response)
    >(sprintQueries.ALL_SPRINTS_BY_BOARD_ID, 'allSprints');
    return {
        getAllSprintsLoading: isLoading,
        getAllSprintsResponse: data,
        getAllSprints: fetchPaginated,
        afterCreateUpdateHandler: upsertItemState,
    };
};

export const useCreateSprint = () => {
    const {invokeSuccessMessage} = useAlert();
    const [refetch, {loading, data}] = useMutation<
        {createSprint: SprintResponseModel},
        {input: SprintCreateUpdateRequestModel}
    >(sprintMutations.CREATE_SPRINT);

    useEffect(() => {
        if (!loading && data) {
            invokeSuccessMessage('sprint created successfully');
        }
    }, [loading, data]);

    return {
        createSprint: refetch,
        createSprintLoading: loading,
        createSprintResponse: data?.createSprint,
    };
};

export const useUpdateSprint = () => {
    const {invokeSuccessMessage} = useAlert();
    const [refetch, {loading, data}] = useMutation<
        {updateSprint: SprintResponseModel},
        {input: SprintCreateUpdateRequestModel}
    >(sprintMutations.UPDATE_SPRINT);

    useEffect(() => {
        if (!loading && data) {
            invokeSuccessMessage('sprint updated successfully');
        }
    }, [loading, data]);

    return {
        updateSprint: refetch,
        updateSprintLoading: loading,
        updateSprintResponse: data?.updateSprint,
    };
};
